export const useUnitConverter = () => {
  const convert = (fromUnits, toUnits, value, round = false) => {
    let converted;

    // Distance
    if (fromUnits === 'ft' && toUnits === 'km') {
      converted = value * 0.0003048;
    }

    if (fromUnits === 'ft' && toUnits === 'm') {
      converted = value / 3.2808399
    }

    // Speed
    if (fromUnits === 'mph' && toUnits === 'kts') {
      converted = value * 1.609344;
    }

    if (fromUnits === 'kts' && toUnits === 'mph') {
      converted =  value / 0.868976242;
    }
    
    return round ? Math.round(converted) : converted
  }

  return { convert }
}

